import { AuthorResponse, MediaResponse } from "./common";
import { FeedbackStatus } from "./feedback";
import { LabelColorOptions } from "@primer/react";

export interface UserAppealsRequest {
  limit?: number;
  offset?: number;
  ordering?: UserAppealsOrderingField;
  search?: string;
  status?: FeedbackStatus;
  topic_id?: string;
}

export interface AppealReplyRequest {
  text: string;
  media: string[];
}

export interface AppealTopicsRequest {
  limit?: number;
  offset?: number;
}

export type UserAppealsOrderingField = "created_at" | "-created_at";

export interface AppealTopicResponse {
  id: string;
  title: string;
  media: MediaResponse[];
}

export interface UserAppealResponse {
  id: string;
  createdAt: string;
  email: string;
  text: string;
  reply: string;
  repliedAt: string;
  topic: AppealTopicResponse;
  user: AuthorResponse | undefined;
  media: MediaResponse[];
  status: FeedbackStatus;
}

export interface UserAppealsListResponse {
  list: UserAppealResponse[];
  totalCount: string;
}

export interface AppealFileDeleteRequest {
  ids: string[];
}

export interface AppealRepliesRequest {
  created_from?: string;
  created_to?: string;
  limit?: number;
  offset?: number;
  ordering?: AppealRepliesOrderingField[];
  search?: string;
}

export type AppealRepliesOrderingField = "created_at" | "-created_at";

export interface AppealReplyResponse {
  id: string;
  createdAt: string;
  text: string;
  media: MediaResponse[];
  appealId: string;
}

export interface AppealRepliesListResponse {
  list: AppealReplyResponse[];
  totalCount: string;
}

export enum AppealTopic {
  Technical = "Техническая",
  Suggestions = "Предложения",
  Complaint = "Пожаловаться",
  Moderation = "Модерация",
  Verification = "Верификация",
  Other = "Другое",
}

export interface AppealStatusUpdateRequest {
  ids: string[];
  status: FeedbackStatus;
}

export function getColorVariantForAppealTopic(
  topic: AppealTopic
): LabelColorOptions {
  switch (topic) {
    case AppealTopic.Technical:
      return "accent";
    case AppealTopic.Suggestions:
      return "success";
    case AppealTopic.Complaint:
      return "danger";
    case AppealTopic.Moderation:
      return "attention";
    case AppealTopic.Verification:
      return "done";
    default:
      return "primary";
  }
}

export function getAppealFromString(value: string): AppealTopic | undefined {
  switch (value) {
    case AppealTopic.Technical:
      return AppealTopic.Technical;
    case AppealTopic.Suggestions:
      return AppealTopic.Suggestions;
    case AppealTopic.Complaint:
      return AppealTopic.Complaint;
    case AppealTopic.Moderation:
      return AppealTopic.Moderation;
    case AppealTopic.Verification:
      return AppealTopic.Verification;
    case AppealTopic.Other:
      return AppealTopic.Other;
    default:
      return undefined;
  }
}
